import { withHook } from 'utils/withHook';
import { ReviewItemView } from 'containers/ReviewItem/view/ReviewItemView';
import { useReviewItemState } from 'containers/ReviewItem/logic/useReviewItemState';

export const ReviewItem = withHook(useReviewItemState)(ReviewItemView);
